import { Formio } from '@formio/js';
import bootstrap from '@formio/bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@formio/js/dist/formio.form.min.css';

// Register the Bootstrap 5 framework templates so rendered forms are styled
// (inputs, layout, buttons) rather than the bare default template. This
// side-effecting module must be imported once before any Formio.createForm() call.
(Formio as unknown as { use(module: unknown): void }).use(bootstrap);
